// Path: ./src/utils/CheckJWT/index.ts
import { adminApiServiceRaw, normalizeApiResult } from "../api";
import posthog from "posthog-js";
import { clearAuthToken } from "../authTokenStorage";
import { readApiError } from "../apiError";
import { toastError } from "../pageUtil/toast";

export const useVerifyJWTToken = async (jwtToken?: string) => {
  if (jwtToken) {
    try {
      // Raw client: we need the real status to tell "token is dead" apart
      // from "server/network hiccup".
      const adminUser = normalizeApiResult(
        await adminApiServiceRaw.gfAdminUserAdminControllerVerifyToken(jwtToken),
      );
      try {
        // Somewhere in your login or user init flow:
        posthog.identify(adminUser.id);

        // Optionally set user properties
        posthog.people.set({
          email: adminUser.email,
          name: adminUser.firstName + " " + adminUser.lastName,
        });
      } catch (error) {
        console.error("Error setting posthog user properties", error);
      }
      return adminUser;
    } catch (error) {
      const { status, message } = await readApiError(error);
      if (status === 401) {
        // Expired or invalid token: drop it so the user lands on the login page.
        clearAuthToken();
      } else {
        // Network error or server trouble: keep the token so a reload can
        // pick the session back up instead of forcing a fresh login.
        console.error("Token verification failed", error);
        toastError(`Couldn't reach the server (${message}). Please reload.`);
      }
      return undefined;
    }
  }
  return undefined;
};
